// extracted by mini-css-extract-plugin
export default {"Link":"Link___ZxNil"};